import React, { useEffect, useRef } from 'react'
import { Col, Image, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { animated } from 'react-spring'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import tfbank21_logo_white from 'img/tf-logos/tfbank21-logo-white.svg'
import closIcon from 'img/icons/close_icon.svg'
import { menuItems } from 'constants/menuItems/menuItems'
import ChangeLanguage from '../ChangeLanguage/ChangeLanguage'


interface IMenu {
	hide: any
	props: any
	userName: string
}

function Menu({ hide, props, userName }: IMenu) {

	const node = useRef<any>()

	const handleClick = (e: any) => {
		if (node.current.contains(e.target)) {
			return
		}
		hide()
	}

	useEffect(() => {
		document.addEventListener('mousedown', handleClick)
		return () => {
			document.removeEventListener('mousedown', handleClick)
		}
	})

	const { t } = useTranslation()

	const logo = tfbank21_logo_white

	return (
		<>
			<animated.div className="overlay pointer">
				<animated.div
					style={props}
					ref={node}
					id="container-menu-desktop"
					className="container-menu">
					<Row>
						<Col xs={6}>
							<Image
								src={logo}
								className="img-responsive pt-2 pl-2 tfbank-logo-menu"
								alt="TF Bank AB"
							/>
						</Col>
						<Col xs={3}></Col>
						<Col xs={2} className="text-center">
							<Image
								src={closIcon}
								className="close-icon pt-3 pr-2"
								alt="TF Bank AB"
								onClick={hide}
							/>
						</Col>
					</Row>

					<hr />
					<div className="pl-4">
						<Row className="mb-1">
							<Col xs={12}>
								<p className="text-left">
									{t('Hello')} {userName}!
								</p>
							</Col>
						</Row>
						{menuItems.map((link, i) => (
							<Link
								key={'link-' + i}
								to={link.route}
								onClick={hide}>
								<Row className="pt-3 pb-3 row-hover">
									<Col xs={2}>
										{link.faIcon ? (
											<FontAwesomeIcon
												icon={link.faIcon}
											/>
										) : (
											<>
												{link.imgPath ? (
													<Image
														src={link.imgPath}
														className="icon-user"
														alt={t(link.text)}
													/>
												) : (
													<FontAwesomeIcon
														icon={'user'}
													/>
												)}
											</>
										)}
									</Col>
									<Col xs={10}>
										<div className="text-left">
											{t(link.text)}
										</div>
									</Col>
								</Row>
							</Link>
						))}
						<div className="language-title">{t('Language')}</div>

						<ChangeLanguage />
					</div>
				</animated.div>
			</animated.div>
		</>
	)
}

export default Menu